import React from "react";
import { View, ImageBackground, Platform } from "react-native";
import CustomAlert from "../../components/common/CustomAlert";
import { BRANDING_BACKGROUND_IMAGE } from "../../resources/IMAGES";
import { LOGIN_ROUTE } from "../../navigation/NavigationConstants";
import { useLoginFlow } from "@lib/hooks/login/useLoginFow";
import { styles } from "./style";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import { messages } from "../../resources/strings";
import { isGradientAllowed } from "@lib/utilities/Constants";
import GradientBackground from "../../components/gradient-background/GradientBackground";
import LoginView from "../../components/login/LoginView";

const LoginScreen = () => {
  const { errorHandle, handleLogin, setErrorHandle, isLoading } =
    useLoginFlow();

  let Content = () => (
    <>
      <View style={styles.contentContainer}>
        <LoginView onLoginPress={handleLogin} />
      </View>
      {isLoading && <FullScreenLoader screenName={LOGIN_ROUTE} />}
      {errorHandle !== messages.error.noError && (
        <View style={styles.errorView}>
          <CustomAlert
            data={{ message: errorHandle, screenName: LOGIN_ROUTE }}
            onEndTimer={() => setErrorHandle(messages.error.noError)}
          />
        </View>
      )}
    </>
  );

  if (isGradientAllowed && Platform.OS !== "web") {
    return (
      <GradientBackground
        styles={styles.container}
        testID="login-page-container-gradient"
      >
        <Content />
      </GradientBackground>
    );
  }
  return (
    <ImageBackground
      source={BRANDING_BACKGROUND_IMAGE}
      testID="login-page-container-image"
      style={[styles.container, isGradientAllowed && styles.gradientBg]}
    >
      <Content />
    </ImageBackground>
  );
};

export default LoginScreen;
